import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import { handleImageEleModal, uploadImages } from "BadgeDesignAction";
import { showError } from "ReduxErrorBar";
import { IMAGE_PATH, NEW_IMAGE_PATH, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class AddImages extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, uploadedFiles: {} };

    this.close = this.close.bind(this);
  }

  close() {
    this.props.handleImageEleModal({ show: false });
    this.setState({
      uploadedFiles: {},
      loading: false,
    });
  }

  onDrop(files) {
    var file = files[0];
    // console.log("file :- ", file);

    var imageData = {};
    var reader = new FileReader();
    // Determine if it is a valid file...
    if (file && file.type.indexOf("image") !== -1) {
      var uploadedimage = new Image();
      uploadedimage.addEventListener("load", () => {
        reader.onloadend = () => {
          let width = uploadedimage.width;
          let height = uploadedimage.height;

          imageData = {
            imagefile: reader.result,
            width: width,
            height: height,
          };
        };
        reader.readAsDataURL(file);
      });
      uploadedimage.src = window.URL.createObjectURL(file);
    }

    setTimeout(() => {
      // console.log("imageData :- ", imageData);
      this.setState({
        uploadedFiles: imageData,
      });
    }, 300);
  }

  processUpload = () => {
    let { showModal } = this.props;
    let { uploadedFiles } = this.state;

    this.setState({ loading: true });
    this.props.uploadImages(this.props.session, uploadedFiles, (response) => {
      // console.log("response :- ", response);
      this.setState({ loading: false });
      if (response.success) {
        this.close();
        this.props.imageCallback({
          ...response.data,
          ...uploadedFiles,
          ...(!_.isEmpty(showModal.data) ? { existing: showModal.data } : {}),
        });
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  render() {
    let { showModal } = this.props;
    let { uploadedFiles, loading } = this.state;
    // console.log("showModal :- ", showModal);

    let disabled = true;
    if (_.size(uploadedFiles) > 0) {
      disabled = false;
    }
    if (loading) {
      disabled = true;
    }

    var overlayStyle = {
      width: "100%",
      height: "85%",
      padding: "130px 0",
      textAlign: "center",
      border: "1px dashed #2676ea",
      background: "white",
      borderRadius: 5,
    };

    var overlayStyle1 = {
      width: "100%",
      height: 350,
      padding: "15px 0px",
      border: "1px dashed #2676ea",
      borderRadius: 5,
      background: "white",
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
    };

    var mapImage = {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: 5,
    };

    return (
      <div className="badge-elemet-image-modal-container">
        <Modal
          className="modal-container"
          show={showModal.show === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          size="lg"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.upload_image}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src={`${IMAGE_PATH}custom-icons/cross-black.png`}
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <>
              {!_.isEmpty(uploadedFiles) ? (
                <div style={overlayStyle1}>
                  <img style={mapImage} src={uploadedFiles.imagefile} />
                </div>
              ) : (
                <div className="dropzone">
                  <Dropzone
                    accept="image/jpeg, image/png"
                    onDrop={this.onDrop.bind(this)}
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div style={overlayStyle}>
                        <div {...getRootProps()} className="drop-text">
                          <div>
                            <img src={`${NEW_IMAGE_PATH}picture.png`} />
                          </div>
                          <div className="custom-text2-secondary-normal">
                            {LocaleStrings.upload_image_text}
                          </div>
                          <input {...getInputProps()} />
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              )}
            </>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.close()}
              className="btn btn-custom-white"
              type="button"
            >
              {LocaleStrings.button_close}
            </button>
            <Button
              bsStyle=""
              className="btn btn-custom-blue ml-10"
              type="button"
              loading={loading}
              onClick={this.processUpload}
              disabled={loading || disabled}
            >
              {LocaleStrings.button_save_changes}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.imageElementModal,
  };
}

export default connect(mapStateToProps, {
  handleImageEleModal,
  uploadImages,
  showError,
})(AddImages);
